import React from 'react';
import { get, post, put, del } from '../../Utility/Http';
import { getCoachApiGet} from './CoachModel';
import Config from '../../Utility/Config';

export const getCoachListApi = async () => {
    console.log(process.env.EXTENDED_URL);
    const response = await get(`${Config.EXTENDED_URL}admin/get-coach`, null);
    return getCoachApiGet(response);
};


